import React from "react";
//#region types
import { TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { TodoPostWithoutPictureSectionProps } from "models/propTypes/missingDocumentPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { VerticalFormField, Toggle, InlineLabel, TextInput } from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const TodoPostWithoutPictureSection: React.FC<TodoPostWithoutPictureSectionProps> = ({
  values,
  connect,
  hasMatchedDocument,
  amount,
}) => {
  return (
    <>
      {!!values.filesToUpload?.length ? (
        <></>
      ) : (
        <Grid container direction="row" wrap="nowrap">
          <InlineLabel
            columns
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.MissingDocument.PostWithoutPictureDescription
            )}
          >
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MissingDocument.PostWithoutPicture)}
          </InlineLabel>

          <Grid item>
            <Toggle {...connect("postWithoutPicture")} />
          </Grid>
        </Grid>
      )}

      {!values.postWithoutPicture && !hasMatchedDocument && amount < 0 ? (
        <></>
      ) : (
        <VerticalFormField<TextInputProps>
          Component={TextInput}
          {...connect("explanation")}
          controlLabel={TranslationKeys.MissingDocument.ReasonForTransaction}
          label={TranslationKeys.Common.Reply}
          icon={IconDefinitionConstants.WCommentDots}
          showMainLabel
          messageBubblePlacement="top-end"
        />
      )}
    </>
  );
};

export default TodoPostWithoutPictureSection;
